import { jsx as _jsx } from "react/jsx-runtime";
import IntlMessageFormat from "intl-messageformat";
import * as Styled from "./InteractiveMenuListItem.styled";
export const MenuListItemCheckBox = (_props) => {
    const { checkStyle, disabled, hasNestedChildren, checked, inputProps, label, nestedGroupLabel, value, ...props } = _props;
    return (_jsx(Styled.OptionCheckbox, { checked: checked, disabled: disabled, isParent: hasNestedChildren, checkStyle: checkStyle, label: _jsx(Styled.OptionCheckboxLabel, { children: hasNestedChildren && nestedGroupLabel
                ? typeof nestedGroupLabel === "function"
                    ? nestedGroupLabel(label)
                    : // TODO: render using React or add a required string label prop
                        new IntlMessageFormat(nestedGroupLabel).format({ label })
                : label }), value: value, inputProps: { ...inputProps, "data-primary-focus-target": true }, ...props }));
};
